import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomeramendmentComponent } from './customeramendment.component';

const routes: Routes = [
    {
        path: '',
        component: CustomeramendmentComponent,
        data: {
            title: 'Customer Amendment'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class  CustomeramendmentRoutingModule { }
